// import fs from 'fs'
import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSpinner,
  faUsers,
  faCalendarAlt,
  faBook,
  faChartArea,
  faSignOutAlt,
  faCalendarPlus,
  faObjectGroup,
  faPlusCircle,
  faSortAlphaDownAlt,
  faSortAlphaDown,
  faUndo,
  faUserCog,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faPlus,
  faBars,
  faCheck,
  faMinus,
  faComment,
  faEnvelope,
  faPhone,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueProgressBar from 'vue-progressbar'
import axios from 'axios'
import App from './app.vue'
import { changeset } from './REVISION.json'

// Globally register all `_base`-prefixed components
import '@components/_globals'

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      window.location = '/'
      return null
    }

    return Promise.reject(error)
  },
)

// Font Awesome icons
library.add(faSpinner)
library.add(faUsers)
library.add(faCalendarAlt)
library.add(faBook)
library.add(faChartArea)
library.add(faSignOutAlt)
library.add(faCalendarPlus)
library.add(faObjectGroup)
library.add(faPlusCircle)
library.add(faSortAlphaDownAlt)
library.add(faSortAlphaDown)
library.add(faUndo)
library.add(faUserCog)
library.add(faChevronLeft)
library.add(faChevronRight)
library.add(faChevronDown)
library.add(faChevronUp)
library.add(faPlus)
library.add(faBars)
library.add(faCheck)
library.add(faMinus)
library.add(faComment)
library.add(faEnvelope)
library.add(faPhone)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Loading indicator
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px',
})

// Exceptions reporting
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ccbde1094a534b409af7acf5f85023bb@o332614.ingest.sentry.io/5220362',
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    release: changeset,
    ignoreErrors: [
      // Ignore common network errors
      'Request aborted',
      'Network Error',
      'Request failed with status code 400',
    ],
  })
}

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.filter('roleDisplay', (role) => {
  if (role === 'admin') {
    return 'Administratorius'
  }
  if (role === 'coordinator') {
    return 'Koordinatorius'
  }
  return 'Savanoris'
})

Vue.filter('statusDisplay', (status) => {
  if (status === 1) {
    return 'Aktyvus'
  }
  if (status === 2) {
    return 'Negalioja'
  }
  if (status === 3) {
    return 'Sustabdyta'
  }
})

Vue.filter('countDisplay', (count) => {
  if (count === 0) return '0 įrašų'
  if (count === 1) return '1 įrašas'
  if (count < 1) return `${count} įrašai`
  if (count % 10 === 0) return `${count} įrašų`
  if (count > 20 && count % 10 === 1) return `${count} įrašas`
  if (count > 10 && count < 20) return `${count} įrašų`

  return `${count} įrašai`
})

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
